"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var Box_1 = require("../Box");
var InfiniteScroll = /** @class */ (function (_super) {
    tslib_1.__extends(InfiniteScroll, _super);
    function InfiniteScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialScroll = false;
        _this.aboveMarkerRef = React.createRef();
        _this.belowMarkerRef = React.createRef();
        _this.state = {};
        _this.addScrollListener = function () {
            var pageHeight = _this.state.pageHeight;
            if (pageHeight && _this.belowMarkerRef.current && !_this.scrollParents) {
                _this.scrollParents = utils_1.findScrollParents(_this.belowMarkerRef.current);
                _this.scrollParents.forEach(function (scrollParent) { return scrollParent.addEventListener('scroll', _this.onScroll); });
            }
        };
        _this.removeScrollListener = function () {
            if (_this.scrollParents) {
                _this.scrollParents.forEach(function (scrollParent) { return scrollParent.removeEventListener('scroll', _this.place); });
                _this.scrollParents = undefined;
            }
        };
        _this.scrollShow = function () {
            var show = _this.props.show;
            if (show && !_this.initialScroll && _this.showRef) {
                _this.initialScroll = true;
                // on initial render, scroll to any 'show'
                _this.showRef.scrollIntoView();
            }
        };
        _this.setPageHeight = function () {
            var pageHeight = _this.state.pageHeight;
            if (_this.firstPageItemRef && _this.lastPageItemRef && !pageHeight) {
                var beginRect = _this.firstPageItemRef.getBoundingClientRect();
                var endRect = _this.lastPageItemRef.getBoundingClientRect();
                var nextPageHeight = endRect.y + endRect.height - beginRect.y;
                // In case the pageHeight is smaller than the visible area,
                // we call onScroll to set the page boundaries appropriately.
                _this.setState({ pageHeight: nextPageHeight }, _this.onScroll);
            }
        };
        _this.onScroll = function () {
            var _a = _this.props, onMore = _a.onMore, replace = _a.replace;
            var _b = _this.state, beginPage = _b.beginPage, endPage = _b.endPage, lastPage = _b.lastPage, pageHeight = _b.pageHeight;
            if (_this.scrollParents && _this.scrollParents[0] && pageHeight) {
                var scrollParent = _this.scrollParents[0];
                // Determine the window into the first scroll parent
                var top_1;
                var height = void 0;
                if (scrollParent === document) {
                    // Make sure doumentElement is available
                    top_1 = document.body.scrollTop;
                    height = window.innerHeight;
                }
                else {
                    top_1 = scrollParent.scrollTop;
                    var rect = scrollParent.getBoundingClientRect();
                    (height = rect.height);
                }
                // Figure out which pages we should make visible based on the scroll window.
                var offset = height / 4;
                var nextBeginPage = replace
                    ? Math.min(lastPage, Math.max(0, Math.floor(Math.max(0, top_1 - offset) / pageHeight)))
                    : 0;
                var nextEndPage_1 = Math.min(lastPage, Math.max((!replace && endPage) || 0, Math.floor((top_1 + height + offset) / pageHeight)));
                if (nextBeginPage !== beginPage || nextEndPage_1 !== endPage) {
                    _this.setState({ beginPage: nextBeginPage, endPage: nextEndPage_1 }, function () {
                        if (onMore && nextEndPage_1 === lastPage) {
                            onMore();
                        }
                    });
                }
            }
        };
        return _this;
    }
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var items = nextProps.items, show = nextProps.show, step = nextProps.step;
        // Just double check that step & items exist, seems to be a problem with optional props
        if (items && step) {
            var lastPage = Math.ceil(items.length / step) - 1;
            if (prevState.beginPage === undefined ||
                (show && show >= step * (prevState.lastPage + 1)) ||
                lastPage !== prevState.lastPage) {
                var endPage = prevState.endPage || 0;
                if (show && show >= step * (endPage + 1)) {
                    endPage = Math.floor((show + step) / step) - 1;
                }
                return { beginPage: 0, endPage: endPage, lastPage: lastPage, pageHeight: undefined };
            }
        }
        return null;
    };
    InfiniteScroll.prototype.componentDidMount = function () {
        var _this = this;
        // ride out any animation, 100ms was chosen empirically
        this.animationDelayTimer = setTimeout(function () {
            _this.setPageHeight();
            _this.addScrollListener();
            _this.scrollShow();
        }, 100);
    };
    InfiniteScroll.prototype.componentDidUpdate = function () {
        this.setPageHeight();
        this.removeScrollListener();
        this.addScrollListener();
        this.scrollShow();
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        this.removeScrollListener();
        clearTimeout(this.animationDelayTimer);
        clearTimeout(this.scrollTimer);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, items = _a.items, onMore = _a.onMore, renderMarker = _a.renderMarker, replace = _a.replace, show = _a.show, step = _a.step;
        var _b = this.state, beginPage = _b.beginPage, endPage = _b.endPage, lastPage = _b.lastPage, pageHeight = _b.pageHeight;
        var firstIndex = beginPage * step;
        var lastIndex = (endPage + 1) * step - 1;
        var result = [];
        if (replace && pageHeight && firstIndex) {
            var marker = React.createElement(Box_1.Box, { key: "above", ref: this.aboveMarkerRef, flex: false, height: beginPage * pageHeight + "px" });
            if (renderMarker) {
                // need to give it a key
                marker = React.cloneElement(renderMarker(marker), { key: 'above' });
            }
            result.push(marker);
        }
        items.slice(firstIndex, lastIndex + 1).forEach(function (item, index) {
            var itemsIndex = firstIndex + index;
            if (children) {
                var child = children(item, itemsIndex);
                if (!pageHeight && itemsIndex === 0) {
                    var ref_1 = child.ref;
                    child = React.cloneElement(child, {
                        ref: function (node) {
                            _this.firstPageItemRef = node;
                            if (typeof ref_1 === 'function') {
                                ref_1(node);
                            }
                        }
                    });
                }
                else if (!pageHeight && itemsIndex === step - 1) {
                    var ref_2 = child.ref;
                    child = React.cloneElement(child, {
                        ref: function (node) {
                            _this.lastPageItemRef = node;
                            if (typeof ref_2 === 'function') {
                                ref_2(node);
                            }
                        }
                    });
                }
                if (show && show === itemsIndex) {
                    var ref_3 = child.ref;
                    child = React.cloneElement(child, {
                        key: 'show',
                        ref: function (node) {
                            _this.showRef = node;
                            if (typeof ref_3 === 'function') {
                                ref_3(node);
                            }
                        }
                    });
                }
                result.push(child);
            }
        });
        if (endPage < lastPage || replace || onMore) {
            var marker = (React.createElement(Box_1.Box, { key: "below", ref: this.belowMarkerRef, flex: false, height: (replace ? (lastPage - endPage) * pageHeight : 0) + "px" }));
            if (renderMarker) {
                // need to give it a key
                marker = React.cloneElement(renderMarker(marker), { key: 'below' });
            }
            result.push(marker);
        }
        return result;
    };
    InfiniteScroll.defaultProps = {
        items: [],
        step: 10
    };
    return InfiniteScroll;
}(React.PureComponent));
var InfiniteScrollWrapper = InfiniteScroll;
exports.InfiniteScroll = InfiniteScrollWrapper;
//# sourceMappingURL=InfiniteScroll.js.map